<ng-template #contentTemplate>
  <ng-content />
</ng-template>

@if (level === 1) {
  <h1>
    <ng-container *ngTemplateOutlet="contentTemplate" />
  </h1>
}
@if (level === 2) {
  <h2>
    <ng-container *ngTemplateOutlet="contentTemplate" />
  </h2>
}
@if (level === 3) {
  <h3>
    <ng-container *ngTemplateOutlet="contentTemplate" />
  </h3>
}
@if (level === 4) {
  <h4>
    <ng-container *ngTemplateOutlet="contentTemplate" />
  </h4>
}
@if (level === 'none' || level === undefined) {
  <div>
    <ng-container *ngTemplateOutlet="contentTemplate" />
  </div>
}
